// src/App.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import Layout from './components/core/Layout';
import Loading from './components/core/Loading';
import AccessLevelProvider from './components/core/AccessLevelProvider';
import ProtectedRoute from './components/core/ProtectedRoute';

// Lazy load page components
const Login = lazy(() => import('./routes/Login'));
const Home = lazy(() => import('./routes/Home'));
const Access = lazy(() => import('./components/core/Access'));


function App() {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // Wait for MSAL to complete any authentication processes
  if (inProgress !== 'none') {
    return <Loading />;
  }

  return (
    <Router>
      <Suspense fallback={<Loading />}>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/login"
            element={!isAuthenticated ? <Login /> : <Navigate to="/" replace />}
          />
          <Route path="/access-denied" element={<Access />} />

          {/* Protected Routes */}
          {isAuthenticated && (
            <Route
              element={
                <AccessLevelProvider>
                  <Layout />
                </AccessLevelProvider>
              }
            >
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              {/* Default authenticated route */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          )}

          {/* Catch-all for non-authenticated users */}
          {!isAuthenticated && (
            <Route path="*" element={<Navigate to="/login" replace />} />
          )}
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
